// offers or plans
export const OFFER_INFOS_OVERVIEW_ROUTE = ""
export const OFFERS_ROUTES = "/offres/"
export const ADD_OR_MODIFY_OFFER_ROUTE = OFFERS_ROUTES + "ajout-offres"

// clients
export const CLIENTS_PAGE = "/clients/"
export const CLIENT_INFOS_OVERVIEW_ROUTE = CLIENTS_PAGE + "infos/:id/"
export const CLIENT_ABONNEMENT_INFOS_ROUTE = CLIENT_INFOS_OVERVIEW_ROUTE + "subscription/"
export const CLIENT_STEPPERS_ROUTE = CLIENTS_PAGE + "ajout-client/"
export const CLIENT_UPDATE_STEPPERS_ROUTE = CLIENT_STEPPERS_ROUTE + ":id/"

// options
export const ADD_OR_MODIFY_OPTION_ROUTE = "/options/:id/"

// transactions
export const TRANSACTIONS_URL = "/transactions/"

// invoices
export const INVOICES_URL = "/facturation/"
export const ADD_OR_MODIFY_INVOICE_ROUTE = INVOICES_URL + "ajout-facture"